export const dashboardQueryKeys = {
  all: ['fields'] as const,
  lists: () => [...dashboardQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...dashboardQueryKeys.lists(), filters] as const,
  details: () => [...dashboardQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...dashboardQueryKeys.details(), id] as const,
};
